export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14988.f15ae3c5.jpg";